import {
  IconCoin,
  IconStarFilled,
  IconCheck,
  IconCircleCheck,
} from "@tabler/icons-react";
import styles from "./PriceCard.module.css";

export default function PriceCard({
  featured,
  topBadge,
  tierLabel,
  tierLabelColor,
  inlineTag,
  name,
  priceCurrency,
  priceValue,
  pricePeriod,
  customPrice,
  tagline,
  features,
  cta,
  onCtaClick,
}) {
  return (
    <div className={`${styles.priceCard} ${featured ? styles.featured : ""}`}>
      {topBadge && (
        <div className={styles.topBadge}>
          <IconStarFilled size={10} /> {topBadge}
        </div>
      )}

      <div
        className={styles.tierLabel}
        style={tierLabelColor ? { color: tierLabelColor } : undefined}
      >
        {tierLabel}
        {inlineTag && <span className={styles.inlineTag}>{inlineTag}</span>}
      </div>

      <div className={styles.name}>{name}</div>

      <div className={styles.amountRow}>
        {customPrice ? (
          <span className={`${styles.value} ${styles.customValue}`}>
            {customPrice}
          </span>
        ) : (
          <>
            <span className={styles.currency}>{priceCurrency}</span>
            <span className={styles.value}>{priceValue}</span>
            {pricePeriod && (
              <span className={styles.period}>{pricePeriod}</span>
            )}
          </>
        )}
      </div>

      <div className={styles.tagline}>
        {tagline.type === "chip" ? (
          <span className={styles.creditChip}>
            <IconCoin size={12} /> {tagline.text}
          </span>
        ) : (
          tagline.text
        )}
      </div>

      <div className={styles.divider} />

      <ul className={styles.features}>
        {features?.map((f) => (
          <li className={styles.feature} key={f}>
            <span className={styles.featureCheck}>
              <IconCheck size={11} />
            </span>{" "}
            {f}
          </li>
        ))}
      </ul>

      {cta.variant === "subscribed" ? (
        <button className={`${styles.cta} ${styles.ctaSubscribed}`}>
          <IconCircleCheck size={15} /> {cta.label}
        </button>
      ) : (
        <button className={styles.cta} onClick={onCtaClick}>
          {cta.label}
        </button>
      )}
    </div>
  );
}
